import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateFileboxDto } from './create-filebox.dto';

/**
 * Update filebox DTO
 */
export class UpdateFileboxDto extends CreateFileboxDto {
	@TransformInt()
	id!: number;
}
